import { useCallback, useEffect, useState } from "react";
import { getDropDownKnowChannel } from "../../services/customerStakeholder";

const useKnowChannel = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getDropDownKnowChannel();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useKnowChannel;
